// src/components/home/CoursesSection.jsx
import React from 'react';
import styles from './CoursesSection.module.css';
import coursesData from '../../data/courses'; // Import your courses data
import CourseCardDetailed from '../courses/CourseCardDetailed'; // Import the detailed card component

const CoursesSection = () => {
  // Filter for trending courses, specifically two in 'QA & Testing'
  const trendingTestingCourses = coursesData.filter(
    (course) => course.isTrending && course.category === 'QA & Testing'
  ).slice(0, 2);

  // Filter for one trending course in 'Java Development'
  const trendingDevelopmentCourses = coursesData.filter(
    (course) => course.isTrending && course.category === 'Web Development'
  ).slice(0, 1);

  // Combine the selected courses into a single array
  const combinedTrendingCourses = [
    ...trendingTestingCourses,
    ...trendingDevelopmentCourses,
  ];

  return (
    <section className={styles.coursesSection}>
      <h2 className={styles.sectionHeading}>Our Trending Programs</h2>
      <p className={styles.sectionSubtitle}>
        Dive into our most popular and in-demand courses designed to elevate your expertise.
      </p>
      <div className={styles.courseCards}>
        {combinedTrendingCourses.length > 0 ? (
          combinedTrendingCourses.map((course, index) => (
            <CourseCardDetailed
              key={course.id} // Use a unique key for each course
              course={course}
              // Apply animation delay directly via style prop
              style={{ animationDelay: `${0.15 + index * 0.15}s` }}
            />
          ))
        ) : (
          // Display a message if no trending courses are found
          <p className={styles.noCoursesMessage}>
            No trending courses available at the moment. Please check back soon!
          </p>
        )}
      </div>
    </section>
  );
};

export default CoursesSection;